import palette from '~/theme/dark/palette'

export default {
  styleOverrides: {
    dayDisabled: {
      color: palette.text.secondary
    }
  }
}
